module.exports = __webpack_public_path__ + "img/PersonIcon.87e825c9.svg";